"use client";

import {useTranslation} from "react-i18next";
import FollowUpSuggestions from "@/components/chat/FollowUpSuggestions";
import {
   TicketConfirmationChoice,
   ticketConfirmationSuggestionLabel,
} from "@/utils/chat/ticketConfirmationChoices";

type TicketConfirmSuggestionsProps = Readonly<{
   choices: TicketConfirmationChoice[];
   onSelect: (userText: string) => void;
}>;

const TicketConfirmSuggestions = ({choices, onSelect}: TicketConfirmSuggestionsProps) => {
   const {t} = useTranslation("ask");
   const suggestions = choices.map((choice) => ({
      id: choice.id,
      label: ticketConfirmationSuggestionLabel(choice, t),
   }));

   return (
      <FollowUpSuggestions
         suggestions={suggestions}
         onSuggestionClick={(_label, id) => {
            const choice = choices.find((item) => item.id === id);
            if (choice) {
               onSelect(choice.userText);
            }
         }}
      />
   );
};

export default TicketConfirmSuggestions;
